export const DocumentSourceTypes = {
  Order: 'order',
  Transaction: 'transaction'
};
